export default __webpack_public_path__ + "static/logo-google-9f463ca1bf11bc70eb56f36428b0a578.png";